import classNames from "classnames/bind"
import PropTypes from "prop-types"
import React from "react"
import { useSelector } from "react-redux"

import { useTranslate } from "context/translateContext"
import { getCurrencyLocaleValue } from "data/utils/formaters"
import unavailableIcon from "shared/images/icons/unavailable.svg"

import gridStyles from "../../../components/Plans.module.css"

const cx = classNames.bind(gridStyles)

const bodyClass = cx("row", "planCell")

const FreeOfTransactionFee = props => {
  const { plans } = props
  const { t: translate } = useTranslate()
  const lang = useSelector(state => state.i18nState.lang)

  const renderPlanContent = (freeTier, currency) => {
    if (!freeTier || !freeTier.savingsAmount || !freeTier.freeOfFeeAmount) {
      return <img src={unavailableIcon} alt="Unavailable" />
    }

    const formattedFreeOfFeeAmount = getCurrencyLocaleValue({
      value: freeTier.freeOfFeeAmount,
      currency,
      lang,
      fractionDigits: 0,
    })

    const formattedSavingsAmount = getCurrencyLocaleValue({
      value: freeTier.savingsAmount,
      currency,
      lang,
    })

    return (
      <div className="flex-container f-d-col f-a-center f-j-center">
        <p className={gridStyles.feeText}>{formattedFreeOfFeeAmount}</p>
        <div className="p-5 c-blue bg-motive--light radius-5">
          {translate("Save up to {amount}", {
            amount: formattedSavingsAmount,
          })}
        </div>
      </div>
    )
  }

  return (
    <>
      <div className={cx(bodyClass, "mobileHeading", "featureDescriptionCell")}>
        <p className={gridStyles.sectionTitleDark}>
          {translate("Free of transaction fee")}
        </p>
        <span className={gridStyles.sectionHelperText}>
          {translate("(included sales)")}
        </span>
      </div>
      {plans.map(plan => (
        <div
          key={`FREE_OF_TRANSACTION_FEE_${plan.name}`}
          className={cx(
            bodyClass,
            "flex-container",
            "f-j-center",
            "f-a-center"
          )}
        >
          {renderPlanContent(plan.freeTier, plan.price.currency)}
        </div>
      ))}
    </>
  )
}

FreeOfTransactionFee.propTypes = { plans: PropTypes.array }
FreeOfTransactionFee.defaultProps = { plans: [] }

export default FreeOfTransactionFee
